import { Component, h, State, Event, EventEmitter } from '@stencil/core';

const FEEDBACK_STORAGE_KEY = 'pennlibs-feedback-answer';
const FEEDBACK_QUESTION = 'Did you find what you need?';
const FEEDBACK_ERROR_STORAGE_KEY = 'pennlibs-feedback-error';

@Component({
  tag: 'pennlibs-feedback',
  styleUrl: 'pennlibs-feedback.css',
  shadow: true,
})
export class PennlibsFeedback { 
  @State() error: boolean = false;
  @State() answer: string | undefined = undefined;

  @Event({
    eventName: 'pennlibs-feedback',
    composed: true,
    cancelable: true,
    bubbles: true,
  }) feedbackEvent!: EventEmitter<{
    question: string;
    answer: string;
    url: string;
    pageHeading?: string;
    pageTitle?: string;
  }>;

  private yesMessageRef?: HTMLParagraphElement;
  private noMessageRef?: HTMLParagraphElement;

  componentWillLoad() {
    if (sessionStorage.getItem(FEEDBACK_STORAGE_KEY)) {
      this.answer = sessionStorage.getItem(FEEDBACK_STORAGE_KEY) as string;
    }

    if (sessionStorage.getItem(FEEDBACK_ERROR_STORAGE_KEY)) {
      this.error = sessionStorage.getItem(FEEDBACK_ERROR_STORAGE_KEY) === 'true';
    }
  }

  componentDidRender() {
    if (this.answer === 'yes' && this.yesMessageRef) {
      this.yesMessageRef.focus();
    } else if (this.answer === 'no' && this.noMessageRef) {
      this.noMessageRef.focus();
    }
  }

  handleFeedback(answer: string) {
    this.answer = answer;
    sessionStorage.setItem(FEEDBACK_STORAGE_KEY, answer);
    
    this.feedbackEvent.emit({
      question: FEEDBACK_QUESTION,
      answer: answer,
      url: window.location.href,
      pageHeading: document.querySelector('h1')?.textContent || undefined,
      pageTitle: document.title || undefined
    });
  }
  
  render() {
    if (this.answer === 'yes') {
      return (
        <div class="feedback-container">
          <p 
            ref={(el) => this.yesMessageRef = el as HTMLParagraphElement}
            tabindex="-1"
          >
            <strong>Thank you</strong> for your feedback! 👍
          </p>
        </div>
      );
    }

    if (this.answer === 'no') {
      return (
        <div class="feedback-container">
          <p 
            ref={(el) => this.noMessageRef = el as HTMLParagraphElement}
            tabindex="-1"
          >
            To <strong>help us improve</strong>, we'd like to know more about your visit. Please <a href="https://www.library.upenn.edu/contact-us">contact us with your feedback</a>.
          </p>
        </div>
      );
    }

    return (
      <div class="feedback-container">
        <h2>{FEEDBACK_QUESTION}</h2>
        <button onClick={() => this.handleFeedback('yes')}>
          👍
          <span>Yes<span class="visually-hidden">, I found what I need.</span></span>
        </button>
        <button onClick={() => this.handleFeedback('no')}>
          👎
          <span>No<span class="visually-hidden">, I didn't find what I need.</span></span>
        </button>
      </div>
    )
  }
}

